import React, { useEffect, useLayoutEffect, useState } from 'react';
// import Toast from "../component/Toast";
import { ModalChaining } from "../component/Global/Modal";
import HCLDX from "@system/config/hcldx";
import System from 'src/helper/system';
// import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
// import Constants from 'src/support/Constants';
import Helper from 'src/helper/Helper';
import liveAuth from 'src/helper/liveAuth';

const NotDeployedToHcldx = React.lazy(() => import("../layout/default/not-deployed-to-hcldx"));
const DeployedToHcldx = React.lazy(() => import("../layout/default/deployed-to-hcldx"));
const DeployedToEverywhere = React.lazy(() => import("../layout/default/deployed-to-everywhere"));
const Theme2Activator = React.lazy(() => import("../layout/default/theme2-activator"));

function DOMAttachToSystem() {
    const [DeployedToEverywhereLoaded, SetDeployedToEverywhereLoaded] = useState(false)
    const { storageName: { GUEST_SESSION_ID }, avUserInfoData: { speedBoatNameLower }} = System
    
    useEffect(() => {
        window.addEventListener('unload', handleUnload);
        
        return () => {
          window.removeEventListener('unload', handleUnload);
        };
      }, []);

      const handleUnload = () => {
        if (localStorage.getItem('isMySessionActive')) {
        window.localStorage.isMySessionActive = parseInt(window.localStorage.isMySessionActive) - 1;
        }
      };

      useLayoutEffect(() => {
        if ((localStorage.getItem('isMySessionActive') === null || localStorage.getItem('isMySessionActive') === undefined) || parseInt(localStorage.getItem('isMySessionActive')) == 0) {
          let session = sessionStorage.getItem('register');
          if (session === null) {
            console.log("CLEAR DATA");
          }
          localStorage.setItem('isMySessionActive', 0);
        }
        window.localStorage.isMySessionActive = parseInt(window.localStorage.isMySessionActive) + 1
        sessionStorage.setItem('register', 1);
      }, []);

    // Confirm
    useEffect(() => {
        if (!localStorage.getItem(GUEST_SESSION_ID) && !liveAuth.check()) {
            let sessionId = Helper.UUID();
            localStorage.setItem(GUEST_SESSION_ID, sessionId);
        }
    }, []);

    return (
        <>
            <DeployedToEverywhere SetDeployedToEverywhereLoaded={() => {
                SetDeployedToEverywhereLoaded(true)
            }} />
            {process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS !== 'yes' &&
                <NotDeployedToHcldx />
            }
            {/* {DeployedToEverywhereLoaded && window.avnet &&
                speedBoatNameLower === Helper.toLowerCase(Constants.speedBoats.EBV) &&
                <Theme2Activator />
            } */}
            {HCLDX.get_REACT_APP_HCL_DX_BASE_URL() &&
                <DeployedToHcldx />
            }
            <ModalChaining />
            {/* <Toast /> */}
        </>
    );
}

export default DOMAttachToSystem;
